import {
  observable,
  action
} from 'mobx'
export default class common {
  @observable openFileToolbarTab = null;
  @observable homeSideTabActive = "home"; //home 主页  share-list 共享列表
  @observable pdfUiInit = null; //初始化pdfui
  
  @action setOpenFileToolbarTab(openFileToolbarTab) {
    this.openFileToolbarTab = openFileToolbarTab
  }
  @action setHomeSideTabActive(homeSideTabActive) {
    //  if (homeSideTabActive === 'share-list') {
    //   if (!window.pdfui) {
    //     this.pdfUiInit();
    //   }
    // }
    this.homeSideTabActive = homeSideTabActive
  }
  @action setPdfUiInit(pdfUiInit) {
    this.pdfUiInit = pdfUiInit
  }
}
